import React from "react";

import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import { useNavigationMenuSlice } from "@redux/slices/navigationMenuSlice";
import Routes from "@navigations/Routes";
import PagesScreen from "@scenes/pages/PagesScreen";

const PagesScreenModal = ({
  isOpen,
  onClose,
  params,
}: {
  isOpen: boolean;
  onClose: () => void;
  params?: any;
}) => {
  const { t } = useTranslation();
  const { navigationData } = useNavigationMenuSlice();
  const tabsData = navigationData?.sections?.filter(
    (item: any) => item?.name === Routes.PagesNavigator
  );
  const tabData = tabsData.find((item: any) => item?.params?.id === params?.id);

  return (
    <Modal
      size={"lg"}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingTop={16}
      headerTitle={t(tabData?.label)}
    >
      <PagesScreen
        route={
          {
            params: {
              ...params,
              headerTitle: t(tabData?.label),
              id: tabData?.params?.id,
              hideBackButton: params?.hideBackButton,
              isModal: true,
            },
          } as any
        }
      />
    </Modal>
  );
};

export default PagesScreenModal;
